module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0113.png.7bab636b.jpg";